import { useState, useEffect } from 'react';

interface DeviceInfo {
  browser: string;
  operatingSystem: string;
  deviceType: string;
  screenWidth: number;
  screenHeight: number;
  language: string;
}

export function useDeviceDetection(): DeviceInfo {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    browser: 'Unknown',
    operatingSystem: 'Unknown',
    deviceType: 'Unknown',
    screenWidth: 0,
    screenHeight: 0,
    language: 'Unknown'
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Browser Detection
      const getBrowser = () => {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
          case agent.includes('edge'):
            return 'Microsoft Edge';
          case agent.includes('opr'):
            return 'Opera';
          case agent.includes('chrome'):
            return 'Google Chrome';
          case agent.includes('trident'):
            return 'Internet Explorer';
          case agent.includes('firefox'):
            return 'Mozilla Firefox';
          case agent.includes('safari'):
            return 'Safari';
          default:
            return 'Unknown Browser';
        }
      };

      // Operating System Detection
      const getOperatingSystem = () => {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
          case agent.includes('win'):
            return 'Windows';
          case agent.includes('mac'):
            return 'macOS';
          case agent.includes('linux'):
            return 'Linux';
          case agent.includes('android'):
            return 'Android';
          case agent.includes('iphone'):
            return 'iOS';
          case agent.includes('ipad'):
            return 'iPadOS';
          default:
            return 'Unknown OS';
        }
      };

      // Device Type Detection
      const getDeviceType = () => {
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
          return 'Mobile/Tablet';
        }
        return 'Desktop';
      };

      // Update device info
      setDeviceInfo({
        browser: getBrowser(),
        operatingSystem: getOperatingSystem(),
        deviceType: getDeviceType(),
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        language: navigator.language
      });
    }
  }, []);

  return deviceInfo;
}

// // Example Usage in a Component
// export default function LoginPage() {
//   const deviceInfo = useDeviceDetection();

//   const handleLogin = async (e:any) => {
//     e.preventDefault();

//   };

//   return (
//     <div>
//       <h2>Current Device Details:</h2>
//       <ul>
//         <li>Browser: {deviceInfo.browser}</li>
//         <li>Operating System: {deviceInfo.operatingSystem}</li>
//         <li>Device Type: {deviceInfo.deviceType}</li>
//         <li>Screen Resolution: {deviceInfo.screenWidth} x {deviceInfo.screenHeight}</li>
//         <li>Language: {deviceInfo.language}</li>
//       </ul>
//       <form onSubmit={handleLogin}>
//         {/* Login form fields */}
//       </form>
//     </div>
//   );
// }